import { Circle, CircleDot, FileText, Receipt } from "lucide-react"

// `direct` is still the stored request type for a payment that isn't linked
// to an existing PO (it builds a hidden order + PO). The card copy is the
// procurement name for that choice. Legacy `no_po` drafts are not offered
// here — edit mode keeps that path without showing the picker.
const OPTIONS = [
  {
    value: "po",
    icon: FileText,
    title: "Link to Purchase Order(s)",
    description: "Create payment request for existing purchase order(s)",
  },
  {
    value: "direct",
    icon: Receipt,
    title: "Non-PO Payment",
    description:
      "Create payment request without linking to any PO (e.g. utilities, reimbursement, other expenses)",
  },
]

const PaymentRequestTypeCards = ({ value, onChange, disabled }) => (
  <div className="prc-types">
    {OPTIONS.map((opt) => {
      const checked = value === opt.value
      const Icon = opt.icon
      return (
        <button
          key={opt.value}
          type="button"
          className={`prc-type${checked ? " is-on" : ""}`}
          aria-pressed={checked}
          disabled={disabled}
          onClick={() => !disabled && onChange(opt.value)}
        >
          <span className="prc-type-ico">
            <Icon aria-hidden />
          </span>
          <span className="prc-type-copy">
            <strong>{opt.title}</strong>
            <span>{opt.description}</span>
          </span>
          <span className="prc-type-radio">{checked ? <CircleDot aria-hidden /> : <Circle aria-hidden />}</span>
        </button>
      )
    })}
  </div>
)

export default PaymentRequestTypeCards
